// src/redux/partnerApi.js
import { apiSlice } from "./apiSlice";

export const partnerApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // ────────────── 소개처 (Agente Partner) ──────────────
        getAgentePartner: build.query({
            query: (id) => ({
                url: `/api/user/agente_partner/v1/${id}`,
                method: "get",
                headers: { token: true },
            }),
        }),
        putAgentePartner: build.mutation({
            query: ({ id, body }) => ({
                url: `/api/user/agente_partner/v1/${id}`,
                method: "put",
                data: body,
                headers: { token: true },
            }),
        }),
        deleteAgentePartner: build.mutation({
            query: (id) => ({
                url: `/api/user/agente_partner/v1/${id}`,
                method: "delete",
                headers: { token: true },
            }),
        }),
        getAgentePartnerList: build.query({
            query: () => ({
                url: `/api/user/agente_partner/v1`,
                method: "get",
                headers: { token: true },
            }),
        }),
        postAgentePartner: build.mutation({
            query: (body) => ({
                url: `/api/user/agente_partner/v1`,
                method: "post",
                data: body,
                headers: { token: true },
            }),
        }),

        // ────────────── 공업사 (Mechanic Partner) ──────────────
        getMechanicPartner: build.query({
            query: (id) => ({
                url: `/api/user/mechanic_partner/v1/${id}`,
                method: "get",
                headers: { token: true },
            }),
        }),
        putMechanicPartner: build.mutation({
            query: ({ id, body }) => ({
                url: `/api/user/mechanic_partner/v1/${id}`,
                method: "put",
                data: body,
                headers: { token: true },
            }),
        }),
        deleteMechanicPartner: build.mutation({
            query: (id) => ({
                url: `/api/user/mechanic_partner/v1/${id}`,
                method: "delete",
                headers: { token: true },
            }),
        }),
        getMechanicPartnerList: build.query({
            query: () => ({
                url: `/api/user/mechanic_partner/v1`,
                method: "get",
                headers: { token: true },
            }),
        }),
        postMechanicPartner: build.mutation({
            query: (body) => ({
                url: `/api/user/mechanic_partner/v1`,
                method: "post",
                data: body,
                headers: { token: true },
            }),
        }),

        // ────────────── 영업자 (Sales Partner) ──────────────
        getSalesPartner: build.query({
            query: (id) => ({
                url: `/api/user/sales_partner/v1/${id}`,
                method: "get",
                headers: { token: true },
            }),
        }),
        putSalesPartner: build.mutation({
            query: ({ id, body }) => ({
                url: `/api/user/sales_partner/v1/${id}`,
                method: "put",
                data: body,
                headers: { token: true },
            }),
        }),
        deleteSalesPartner: build.mutation({
            query: (id) => ({
                url: `/api/user/sales_partner/v1/${id}`,
                method: "delete",
                headers: { token: true },
            }),
        }),
        getSalesPartnerList: build.query({
            query: () => ({
                url: `/api/user/sales_partner/v1`,
                method: "get",
                headers: { token: true },
            }),
        }),
        postSalesPartner: build.mutation({
            query: (body) => ({
                url: `/api/user/sales_partner/v1`,
                method: "post",
                data: body,
                headers: { token: true },
            }),
        }),
    }),
});

export const {
    useGetAgentePartnerQuery,
    usePutAgentePartnerMutation,
    useDeleteAgentePartnerMutation,
    useGetAgentePartnerListQuery,
    usePostAgentePartnerMutation,

    useGetMechanicPartnerQuery,
    usePutMechanicPartnerMutation,
    useDeleteMechanicPartnerMutation,
    useGetMechanicPartnerListQuery,
    usePostMechanicPartnerMutation,

    useGetSalesPartnerQuery,
    usePutSalesPartnerMutation,
    useDeleteSalesPartnerMutation,
    useGetSalesPartnerListQuery,
    usePostSalesPartnerMutation,
} = partnerApi;
